import { render } from "./AutoSlider.vue?vue&type=template&id=0d6c2556"
import script from "./AutoSlider.vue?vue&type=script&lang=js"
export * from "./AutoSlider.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__